module.exports = __webpack_public_path__ + "img/shopee-banner.e23d7d34.jpg";